import React, { useEffect, useState, useMemo } from 'react';
import styles from './PoDCampaign.module.css';
import { LoadingProvider, useLoading } from './Contexts/LoadingContext';
import { ErrorProvider } from './Contexts/ErrorContext';
import Header from './Header/Header';
import Body from './Body/Body';
import LoadingIndicator from '../LoadingIndicator';
import HashParameterService from '../../services/hashParameterService';
import campaignValues from '../../utils/campaignValues';
import 'react-toastify/dist/ReactToastify.css';
import './Pod.css';

const useHashNavigation = (setActiveMainMenu, setIsOrderlineSelected, setHeaderDR) => {
    const hashParamService = new HashParameterService();

    const handleHashChange = () => {
        const orderlinesFromUrl = hashParamService.getParameter('orderlines');
        const newState = orderlinesFromUrl
            ? { menu: 'Delivery Report', selected: true, showDR: true }
            : { menu: 'Overview', selected: false, showDR: false };

        setActiveMainMenu(newState.menu);
        setIsOrderlineSelected(newState.selected);
        setHeaderDR(newState.showDR);
    };

    useEffect(() => {
        handleHashChange();
        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);
};

const useCampaignName = (selectedOrderlineMetaData, customer) => {
    return useMemo(() => {
        if (!selectedOrderlineMetaData || !customer) return "";

        return campaignValues.caluclateCampaignName(
            selectedOrderlineMetaData.alternativeName,
            customer,
            selectedOrderlineMetaData.periodStart,
            selectedOrderlineMetaData.periodEnd
        );
    }, [selectedOrderlineMetaData, customer]);
};

const PoDCampaignContent = ({
    orderData,
    customerId,
    parameters,
    setForceUsePop
}) => {
    const { isLoading } = useLoading();
    const [activeMainMenu, setActiveMainMenu] = useState('Overview');
    const [isOrderlineSelected, setIsOrderlineSelected] = useState(false);
    const [activePage, setActivePage] = useState('Summary');
    const [showHeaderDR, setHeaderDR] = useState(false);
    const [selectedOrderlineMetaData, setSelectedOrderlineMetaData] = useState(null);

    useHashNavigation(setActiveMainMenu, setIsOrderlineSelected, setHeaderDR);

    const campaignName = useCampaignName(selectedOrderlineMetaData, orderData?.customer);

    const handleOrderlineSelected = () => {
        setActiveMainMenu('Overview');
        setIsOrderlineSelected(true);
    };

    return (
        <div className={`${styles.PoDCampaign} proof-of-delivery-global-overrides`}>
            <LoadingIndicator
                loading={isLoading}
                text={parameters.loadingDataText}
            />

            <Header
                showExportButton
                customerName={orderData.customer}
                activeMainMenu={activeMainMenu}
                setActiveMainMenu={setActiveMainMenu}
                showHeaderDRButton={showHeaderDR}
                showOverviewButton
                headerDRButtonExtraText={campaignName}
            />

            <Body
                orderData={orderData}
                customerId={customerId}
                parameters={parameters}
                isOrderlineSelected={isOrderlineSelected}
                onLoadOrderline={handleOrderlineSelected}
                setActivePage={setActivePage}
                activePage={activePage}
                setHeaderDR={setHeaderDR}
                setForceUsePop={setForceUsePop}
                setSelectedOrderlineMetaData={setSelectedOrderlineMetaData}
                campaignName={campaignName}
            />
        </div>
    );
};

const PoDCampaign = (props) => (
    <LoadingProvider>
        <ErrorProvider>
            <PoDCampaignContent {...props} />
        </ErrorProvider>
    </LoadingProvider>
);

export default PoDCampaign;